export var FIELD_TEXT = 'FIELDS_INPUT_TEXT';
export var FIELD_TEXTAREA = 'FIELDS_INPUT_TEXTAREA';
export var FIELD_TITLE = 'FIELDS_ELEMENT_TITLE';
export var FIELD_DESCRIPTION = 'FIELDS_ELEMENT_DESCRIPTION';
export var FIELDS_INPUT_DECISION_RADIOGROUP = 'FIELDS_INPUT_DECISION_RADIOGROUP';
export var FIELDS_START_END_INPUTS = 'FIELDS_START_END_INPUTS';